module.exports = __webpack_public_path__ + "img/credit_amex_icon.462c3044.png";